import React from "react";
import { Datagrid, List, TextField } from "react-admin";

const RnList = props => {
  return (
    <List
      {...props}
      resource="getrnwithalternate"
      basePath="getrnwithalternate"
      filter={{ pn__eq: props.pn, relationCode__eq: props.relationCode }}
      perPage={10}
      bulkActionButtons={false}
      exporter={false}
    >
      <Datagrid
        id="guid"
        rowStyle={(record, index) => ({
          backgroundColor: record.pn != props.pn ? "#eeee9b" : "white",
        })}
      >
        <TextField source="rnRefNo" label="Ref No" />
        <TextField label="RN Order Number" source="rnOrderNumber" />
        <TextField source="pn" />
        <TextField source="sn" />
        <TextField label="Customer" source="relationCode" />
      </Datagrid>
    </List>
  );
};

export default RnList;
